// src/components/SplashScreen.js
import React, { useEffect, useState } from 'react';
import './SplashScreen.css'; // Create this CSS file to style the splash screen
import logo from "../../assets/logo-smaller.png";

const SplashScreen = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000); // 5 seconds

    return () => clearTimeout(timer); // Cleanup timer on component unmount
  }, []);

  return isVisible ? (
    <div className="splash-screen">
      <img src={logo} style={{ maxHeight: '2em', marginRight: 10, display: "inline" }} alt='Tamiloodai' />
      <span>தமிழ் ஓடை</span>      
    </div>
  ) : null;
};

export default SplashScreen;
